import { Link } from "react-router-dom"

const Error = () => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '60vh',
    textAlign: 'center',
    padding: '40px 24px',
    marginTop: '100px',
  }}>
    <div style={{ fontSize: '80px', fontWeight: 700, color: '#e5e7eb', lineHeight: 1 }}>404</div>
    <h1 style={{ fontSize: '24px', fontWeight: 600, color: '#111827', margin: '16px 0 8px' }}>
      Page Not Found
    </h1>
    <p style={{ fontSize: '15px', color: '#6b7280', marginBottom: '32px', maxWidth: '400px' }}>
      The page you were looking for doesn't exist or may have been moved.
    </p>
    <Link to='/' style={{
      background: '#2563eb',
      color: '#ffffff',
      padding: '12px 28px',
      borderRadius: '8px',
      fontWeight: 600,
      fontSize: '14px',
    }}>
      Back to Home
    </Link>
  </div>
)

export default Error
